import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../config/axios';
import { Box, Typography, CircularProgress, Alert, Button } from '@mui/material';

export default function SettingsAmazonCallback() {
    const [status, setStatus] = useState('loading');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('spapi_oauth_code');
        if (!code) {
            setStatus('error');
            setError('Code d\'autorisation Amazon manquant dans l\'URL.');
            return;
        }
        api.post('/api/amazon/oauth/token', { code })
            .then(res => {
                setStatus('success');
            })
            .catch(err => {
                setStatus('error');
                setError(err.response?.data?.error || 'Erreur lors de la récupération du token Amazon.');
            });
    }, []);

    return (
        <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {status === 'loading' && <><CircularProgress /><Typography sx={{ mt: 2 }}>Connexion à Amazon...</Typography></>}
            {status === 'success' && <Alert severity="success">Connexion Amazon réussie !</Alert>}
            {status === 'error' && <Alert severity="error">{error}</Alert>}
            <Button sx={{ mt: 3 }} variant="outlined" onClick={() => navigate('/settings')}>Retour aux paramètres</Button>
        </Box>
    );
} 